import React, { FC, useEffect, useState } from 'react';
import { InputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';
import GdprConsentCheckbox from './gdprConsentCheckbox';
import IGdprConsentFieldCheckbox from '../../../types/gdprConsentField.types';
import { windowService } from '../../../../../utils/window.utils';

type CheckboxId = 1 | 2 | 3;

const GdprConsentField: FC<ValueFieldProps<IGdprConsentFieldCheckbox>> = (props) => {
  const { field, tracker } = props;
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const labels = [field?.model?.title, field?.model?.titleSecond, field?.model?.titleThird];
  const id = field.valueField.id;
  const name = field.valueField.name;
  const [value, setValue] = useState(props.value);
  const [encodedValue, setEncodedValue] = useState('');

  const encodeValue = (rawValue: string): string => windowService()?.btoa(rawValue);

  const handleCheckboxChange = (checkboxId: CheckboxId, isChecked: boolean): void => {
    const values = value.split('|');
    values[checkboxId - 1] = `${isChecked}`;
    const newValue = values.join('|');
    setValue(newValue);
  };

  const getLabel = (checkboxId: CheckboxId) => labels[checkboxId - 1];

  const getValue = (checkboxId: CheckboxId) => (value.split('|')?.[checkboxId - 1] === 'true' ? true : false);

  const getPropsWithErrors = (checkboxId: CheckboxId): ValueFieldProps<InputViewModel> => {
    const { errors } = props;

    if (!errors?.[0]) {
      return props;
    }
    const error = errors[0].split('|')?.[checkboxId - 1];
    return {
      ...props,
      errors: error ? [error] : [],
    };
  };

  const hasAnyError = (checkboxId: CheckboxId) => !!getPropsWithErrors(checkboxId).errors?.length;

  const renderCheckbox = (checkboxId: CheckboxId): JSX.Element => {
    const label = getLabel(checkboxId);

    return (
      <>
        {label && (
          <GdprConsentCheckbox
            field={field}
            id={id}
            value={getValue(checkboxId)}
            tracker={tracker}
            hasAnyError={hasAnyError(checkboxId)}
            label={label}
            onChange={(isChecked: boolean) => handleCheckboxChange(checkboxId, isChecked)}
          />
        )}

        {FieldValidationErrors && <FieldValidationErrors {...getPropsWithErrors(checkboxId)} />}
      </>
    );
  };

  useEffect(() => {
    const encValue = encodeValue(value);
    setEncodedValue(encValue);
    props.onChange(field.valueField.name, encValue, props.isValid, []);
  }, [value]);

  useEffect(() => {
    if (props.value !== encodedValue) {
      setValue(props.value);
      props.onChange(field.valueField.name, encodeValue(value), props.isValid, []);
    }
  }, [props.value]);

  return (
    <div className="sitecore-jss-form__control--additional-checkbox">
      <input id={id} name={name} className="sitecore-jss-form__field" type="hidden" value={value} form="novalidatedform" />

      {[1, 2, 3].map(renderCheckbox)}
    </div>
  );
};

export default GdprConsentField;
